import React, { Component } from 'react'
import { Button, Dialog, DialogTitle, DialogActions } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { CreateNewEnvelopeImages } from '../../utils/mockData';
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Divider from '@mui/material/Divider';


export default class IconDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            iconsList: CreateNewEnvelopeImages,
            selectedIcon:null,
            iconName: null
        };
    }

    selectIcon = (icon) => {
        const nameList = ["christmas", "automobile", "holidays", "homeDeposit", "emergencyFunds", "investments", "education", "godebtfree"]
        nameList.forEach(name => {
            if (icon.includes(name)) {
                this.setState({
                    iconName: name.toLowerCase()
                })
            } else if (icon.length > 1000) {
                this.setState({
                    iconName: "homeDeposit"
                })
            }

        });
        this.setState({ selectedIcon: icon });
    }

    render() {
        return (
            <Dialog maxWidth="md" onClose={() => this.props.closeHandler(null)} open={this.props.showIconDialog}>
            <DialogTitle>
                Select icon for your new envelope
                <IconButton
                    aria-label="close"
                    onClick={() => this.props.closeHandler(null)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>
            </DialogTitle>
    
            <Divider light />
            <CardContent>
                <Grid container rowSpacing={3} columnSpacing={5}>
                    {
                        this.state.iconsList.map((icon) => (
                            <Grid item xs={6} sm={4} md={3} key={icon} display="flex">
                                <Button square className="flex-center-all"
                                    onClick={() => { this.selectIcon(icon) }}
                                    variant="outlined"
                                    color={this.state.selectedIcon === icon ? "primary" : "secondary"}
                                    sx={{
                                        padding: 2,
                                        width: "100%"
                                    }}>
                                    <img src={icon} width="75%" alt="icon option" />
                                </Button>
                            </Grid>
                        ))}
                </Grid>
            </CardContent>
    
            <DialogActions>
                <Button onClick={() => this.props.closeHandler(null)}>Close</Button>
                <Button onClick={() => this.props.closeHandler(this.state.selectedIcon, this.state.iconName)} autoFocus>
                    OK
                </Button>
            </DialogActions>
    
        </Dialog>
        )
    }
}
